import React, { Component } from 'react'
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {setGameScreenNumber} from '../actions/commonActions';
import {playButtonTap} from './PlaySounds';

class GameTopBar extends Component {

 
  showPauseMenu = () => {
    playButtonTap();
    this.props.setGameScreenNumber(3,this.props.screenNumber);
  };

    render() {
      var playTime  = this.props.playTime;
      var score  = this.props.score;
      var timerClass = "time_background";
      if(localStorage.getItem('game_mode') === "free"){
        timerClass = "hidden";
      }
            return(
                <div className = "top_bar">
                  <img src={"/game-skins/build-rev79-TUGQhb2Uf/images/btn_pause.png"} alt="" className="button_pause" onClick = {this.showPauseMenu}/>
                  
                  <div className="score_background">
                    {score}
                  </div>
                  <div className={timerClass}>
                    {playTime}
                  </div>
                  
                  
                  
                </div>
                
            )
    }
}

GameTopBar.propTypes = {
  language:PropTypes.string.isRequired,
  screenNumber:PropTypes.number.isRequired,
  score:PropTypes.number.isRequired,
  playTime:PropTypes.number.isRequired
}
const mapStateToProps = state =>({
  language: localStorage.getItem('language',"en"),
  screenNumber:state.config.screenNumber,
  score:state.config.score,
  playTime:state.config.playTime
});

export default connect(mapStateToProps,{setGameScreenNumber})(GameTopBar);
//export default withRouter(IntroScreen);



// WEBPACK FOOTER //
// ./src/components/GameTopBar.js